import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import successImage from '../../assets/backgrounds/success.png';
import './styles.css';

const Success = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    document.body.classList.add('success-page');
    const codigo = searchParams.get('codigo');
    let timeout;
    let interval;
    if (codigo) {
      const token = localStorage.getItem('auth_token');
      const activateAndInvoice = async () => {
        console.log('[Success] Iniciando ativação e geração de fatura para checkout:', codigo);

        // PATCH para ativar o checkout
        try {
          const activateRes = await fetch(`${import.meta.env.VITE_URL_API}/checkouts/${codigo}`, {
            method: 'PATCH',
            headers: {
              'accept': 'application/json',
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ativoCHECKOUT: 1 })
          });
          console.log('[Success] Resposta da ativação do checkout:', activateRes.status, activateRes.statusText);
          if (!activateRes.ok) {
            const errorText = await activateRes.text();
            console.error('[Success] Erro ao ativar checkout:', errorText);
          }
        } catch (error) {
          console.error('[Success] Exceção ao ativar checkout:', error);
        }

        // Tenta gerar fatura com 1 retry antes de mostrar erro
        let attempts = 0;
        const tryInvoice = async () => {
          attempts += 1;
          console.log(`[Success] Tentativa ${attempts} de gerar fatura para checkout:`, codigo);
          
          try {
            const res = await fetch(`${import.meta.env.VITE_URL_API}/moloni/faturas/${codigo}`, {
              method: 'POST',
              headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${token}`
              }
            });
            
            console.log('[Success] Resposta da geração de fatura:', res.status, res.statusText);
            
            if (res.ok) {
              const data = await res.json();
              console.log('[Success] Fatura gerada com sucesso:', data);
              setLoading(false);
              setSuccess(true);
              // Se havia intenção de plano gratuito, marca como resgatado
              try {
                if (localStorage.getItem('free_plan_pending') === '1') {
                  localStorage.setItem('free_plan_redeemed', '1');
                  localStorage.removeItem('free_plan_pending');
                }
              } catch (e) {
                // Ignora erros de localStorage
              }
              // Inicia contagem regressiva
              interval = setInterval(() => {
                setCountdown(prev => {
                  if (prev === 1) {
                    clearInterval(interval);
                    navigate('/dashboard/invoices');
                  }
                  return prev - 1;
                });
              }, 1000);
              timeout = setTimeout(() => {
                navigate('/dashboard/invoices');
              }, 5000);
            } else {
              const errorText = await res.text();
              console.error(`[Success] Erro na tentativa ${attempts} de gerar fatura:`, errorText);
              
              if (attempts < 2) {
                // Aguarda 1s e tenta novamente
                setTimeout(tryInvoice, 1000);
              } else {
                console.error('[Success] Falha após 2 tentativas de gerar fatura');
                setLoading(false);
                setSuccess(false);
              }
            }
          } catch (error) {
            console.error(`[Success] Exceção na tentativa ${attempts} de gerar fatura:`, error);
            
            if (attempts < 2) {
              setTimeout(tryInvoice, 1000);
            } else {
              console.error('[Success] Falha após 2 tentativas de gerar fatura (exceção)');
              setLoading(false);
              setSuccess(false);
            }
          }
        };

        await tryInvoice();
      };

      activateAndInvoice();
    }
    return () => {
      document.body.classList.remove('success-page');
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [searchParams, navigate]);

  const handleContinue = () => {
    navigate('/dashboard/invoices');
  };

  return (
    <div className="success-page">
      <div className="hero-section">
        <img src={successImage} alt="Sucesso JoviPlanet" />
        <div className="hero-content">
          <div className="hero-titles">
            <h1>
              Parabéns!<br/>
              O Seu pagamento foi efetuado com sucesso!
            </h1>
            <p>Agora você pode começar a usar todos os recursos do seu plano</p>
          </div>
        </div>
      </div>

      <div className="success-container">
        <div className="success-content">
          <div className="success-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#BA824F"/>
            </svg>
          </div>

          {/* Loader e mensagem de espera */}
          {loading && (
            <>
              <h2>Pagamento concluído com sucesso!</h2>
              <p style={{margin:'24px 0',fontSize:18}}>Aguarde, a processar a sua fatura...</p>
              <div className="loader" style={{margin:'32px auto', width:60, height:60, border:'6px solid #eee', borderTop:'6px solid #ba824f', borderRadius:'50%', animation:'spin 1s linear infinite'}}></div>
              <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
              <button className="continue-button" disabled style={{opacity:0.6,marginTop:32}}>Processamento da Fatura</button>
            </>
          )}

          {/* Sucesso e botão liberado */}
          {!loading && success && (
            <>
              <h2>Fatura gerada com sucesso!</h2>
              <p style={{margin:'24px 0',fontSize:18}}>Você será redirecionado em {countdown} segundos...</p>
              <button className="continue-button" onClick={handleContinue} style={{marginTop:32}}>Continuar para o Dashboard</button>
            </>
          )}

          {/* Falha */}
          {!loading && !success && (
            <>
              <h2>Ocorreu um erro ao gerar sua fatura</h2>
              <p style={{margin:'24px 0',fontSize:18}}>Tente novamente ou entre em contato com o suporte.</p>
              <button className="continue-button" onClick={handleContinue} style={{marginTop:32}}>Ir para o Dashboard</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Success; 